document.addEventListener('DOMContentLoaded', function() {
    const links = document.querySelectorAll('a');
    const body = document.querySelector('body');

    links.forEach(link => {
        link.addEventListener('click', function(event) {
            const href = this.getAttribute('href');
            const target = this.getAttribute('target');

            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) { return; }
            if(href[0] == '#') { return true; }
            if(target == '_blank') { return; }
            event.preventDefault(); // 通常のリンク遷移を止める
            // フェードアウト
            body.classList.add('fade-out');

            setTimeout(function() {
                // ページ遷移
                window.location.href = href;
            }, 400); // CSSのtransition-durationと同じ時間
            setTimeout(function() {
                if(body.classList.contains('fade-out')){
                    body.classList.remove('fade-out');
                }
            }, 3600);
        });
    });

    // ページロード時にフェードイン
    window.addEventListener('load', function() {
        body.classList.add('fade');
    });
});